<template>
  <v-container fluid>
    <v-row align="center" class="pa-1">
      <v-card-title>Журнал проезда автомобилей</v-card-title>
      <div>
        <BaseTextField
          v-model="carSearch"
          type-input="string"
          :is-button="false"
          :allow-only-latin="true"
          label="Номер автомобиля"
        />
      </div>
      <v-spacer></v-spacer>
      <v-tooltip bottom v-if="roleName !== 'call-center'">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="border card-footer"
            style="background-color: #cc5500; color: white;"
            v-bind="attrs"
            disabled
            v-on="on"
            @click="downloadReportPage"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-arrow-down-bold-box-outline</v-icon>
          </v-btn>
        </template>
        <span>Скачать отчёт, в разработке...</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="updateInfo"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-reload</v-icon>
          </v-btn>
        </template>
        <span>Обновить</span>
      </v-tooltip>
    </v-row>

    <v-row>
      <v-col cols="12" md="4">
        <v-autocomplete
          v-model="selectedBarrier"
          :items="barrierOptions"
          :item-text="barrierDisplayText"
          item-value="id"
          label="Выберите шлагбаум"
          dense
          outlined
          clearable
          @change="onBarrierChange"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-menu
          v-model="menuFilterDate"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="230px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateRangeFilter"
              label="Промежуток времени"
              outlined
              dense
              hide-details
              style="max-width: 360px;"
              class="input input-search mr-2 pl-3"
              v-on="on"
              prepend-inner-icon="mdi-calendar"
              readonly
            ></v-text-field>
          </template>
          <v-date-picker v-model="dateFilter" @click="menuFilterDate = false" range :max="today">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menuFilterDate = false">
              Назад
            </v-btn>
            <v-btn text color="primary" :disabled="!dateFilter[0]" @click="dateFilter = []">
              Сбросить
            </v-btn>
            <v-btn text color="primary" @click="menuFilterDate = false">
              Выбрать
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>

    <v-data-table
      class="table"
      :headers="headers"
      :items="filtered"
      :loading="loading"
      loading-text="Загрузка данных..."
    >
      <template v-slot:item.createdAt="{item}">
        {{ ruDateFormat(item.date) }}
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn
          text
          class="text-decoration-underline"
          style="min-width: unset; padding: 0;"
          @click="loadImage(item.date)"
        >
          Фотография
        </v-btn>
      </template>
      <template v-slot:item.opening_info="{ item }">
        <div v-if="item.opening_info === '-\r'">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                width="18"
                height="18"
              >
                <v-icon x-small color="red">mdi-checkbox-blank-circle</v-icon>
              </v-btn>
            </template>
            <span>Номер был распознан, но его нет в базе данных.</span>
          </v-tooltip>
        </div>
        <div v-if="item.opening_info === '+\r'">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                width="18"
                height="18"
              >
                <v-icon x-small color="green">mdi-checkbox-blank-circle</v-icon>
              </v-btn>
            </template>
            <span>Номер был распознан и находится в нашей базе данных.</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" :max-width="isMobile ? '90%' : '50%'" @input="dialog = false">
      <zoom-photo
        v-model="dialog"
        :photo="imageSrc"
        @closeZoomPhoto="dialog = false"
      >
      </zoom-photo>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import zoomPhoto from '@/components/client/DetailClient/components/zoomPhoto.vue';
import BaseTextField from '@/components/BaseTextField.vue';

export default {
  name: 'TravelLog',
  mixins: [ruDateFormatMixin],
  components: { BaseTextField, zoomPhoto },
  data () {
    return {
      isMobile: false,
      loading: false,
      dialog: false,
      journal: [],
      today: new Date().toISOString().split('T')[0],
      barrierOptions: [],
      menuFilterDate: false,
      dateFilter: [],
      responseJournal: [],
      resResidentComplex: [],
      base64Image: '',
      startDate: '',
      carSearch: '',
      endDate: '',
      selectedBarrier: null,
      headers: [
        { text: 'Дата и время', value: 'createdAt', align: 'center' },
        { text: 'Номер автомобиля', value: 'car_number', sortable: false, align: 'center' },
        { text: 'Распознание грз', value: 'opening_info', sortable: false, align: 'center' },
        { text: '', value: 'action', sortable: false, width: '8%', align: 'center' },
      ],
    };
  },
  async mounted () {
    await this.getResidentComplex();

    if (window.innerWidth < 600) {
      this.isMobile = true;
    }
    if (this.dateFilter.length === 0) {
      const today = new Date().toISOString().split('T')[0];
      this.dateFilter = [today, today];
    }
  },
  computed: {
    ...mapGetters({
      roleName: 'roleName',
    }),
    filtered () {
      if (this.carSearch) {
        return this.responseJournal.data.filter(item => {
          return item.car_number !== null &&
            String(item.car_number).toLowerCase().includes(this.carSearch.toLowerCase());
        });
      } else {
        return this.responseJournal.data;
      }
    },
    imageSrc () {
      return `data:image/jpeg;base64,${this.base64Image}`;
    },
    dateRangeFilter () {
      let formattedStartDate = '';
      let formattedEndDate = '';
      if (this.dateFilter[0]) {
        formattedStartDate = this.ruDateFormat(this.dateFilter[0], true);
      }
      if (this.dateFilter[1]) {
        formattedEndDate = ` - ${this.ruDateFormat(this.dateFilter[1], true)}`;
      }

      return `${formattedStartDate}${formattedEndDate}`;
    },
  },
  methods: {
    ...mapActions({
      getJournalGrzOpen: 'Barriers/getJournalGrzOpen',
      getImageJournalGrz: 'Barriers/getImageJournalGrz',
      viewComplex: 'ResidentComplex/viewComplex',
    }),
    downloadReportPage () {
      const lines = [];
      this.filtered.forEach((item) => {
        const createdAt = this.ruDateFormat(item.date);
        let openingInfo;
        if (item.opening_info === '-\r') {
          openingInfo = '-';
        } else {
          openingInfo = 'Успешно';
        }
        const line = [
          createdAt, item.car_number, openingInfo,
        ].join(';');
        lines.push(line);
      });
      const link = document.createElement('a');
      link.href = `data:text/csv;charset=CP1251,${this.encodeCP1251(lines.join('\n'))}`;
      link.download = 'Journal-grz.csv';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getDirectionType (direction) {
      switch (direction) {
        case 1: return 'Въезд/Выезд';
        case 2: return 'Только въезд';
        case 3: return 'Только выезд';
        default: return '';
      }
    },
    barrierDisplayText (item) {
      const address = item.address || item.name || 'Без адреса';
      const direction = this.getDirectionType(item.direction);
      return `${address} (${direction})`;
    },
    async updateInfo () {
      if (this.selectedBarrier) {
        const selected = this.barrierOptions.find(b => b.id === this.selectedBarrier);

        if (selected) {
          await this.loadJournalGrz(selected)
            .then(() => {
              this.$flash_success('Таблица обновлена!');
            });
        } else {
          this.$flash_danger('Шлагбаум не найден в списке');
        }
      } else {
        this.$flash_danger('Выберите шлагбаум из списка');
      }
    },
    loadImage (dateTime) {
      if (!this.selectedBarrier) {
        this.$flash_danger('Шлагбаум не выбран');
        return;
      }
      let formattedDateTime = dateTime;
      if (typeof dateTime === 'string') {
        // Обрезаем всё после секунд
        const match = dateTime.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/);
        if (match) {
          formattedDateTime = match[0];
        }
      }

      this.getImageJournalGrz({
        id: this.selectedBarrier,
        dateTime: formattedDateTime,
      })
        .then((data) => {
          this.base64Image = data.data;
          this.dialog = true;
        })
        .catch((err) => {
          console.error(err);
          this.$flash_warning('Не удалось получить изображение журнал грз.');
        });
    },
    getResidentComplex () {
      this.viewComplex(this.$route.params.id)
        .then(async (res) => {
          this.resResidentComplex = res;

          // Оставляем только шлагбаумы с device_id
          this.barrierOptions = (res.barriers || []).filter(barrier => barrier.device_id);

          if (this.barrierOptions.length > 0) {
            const firstBarrier = this.barrierOptions[0];
            this.selectedBarrier = firstBarrier.id;

            await this.loadJournalGrz(firstBarrier);
          } else {
            this.$flash_danger('Нет шлагбаумов с устройствами (device_id)');
          }
        })
        .catch((e) => {
          console.error(e);
          this.$flash_warning('Ошибка при загрузке жилого комплекса');
        });
    },
    async onBarrierChange (barrierId) {
      const selected = this.barrierOptions.find(b => b.id === barrierId);
      if (selected) {
        await this.loadJournalGrz(selected);
      }
    },

    async loadJournalGrz (item) {
      // если дата не указана, то автоматически подставляется текущий день
      if (this.dateFilter[1]) {
        this.startDate = this.dateFilter[0] + ' 00:00:00';
        this.endDate = this.dateFilter[1] + ' 23:59:59';
      }
      this.loadingList = true;
      await this.getJournalGrzOpen({
        id: item.id,
        startDate: this.startDate,
        endDate: this.endDate,
        sort: this.sort,
      })
        .then((data) => {
          this.responseJournal = data.data;
        })
        .catch((err) => {
          console.error(err);
          this.$flash_warning('Не удалось получить журнал грз. Нет записей.');
        })
        .finally(() => {
          this.loadingList = false;
        });
    },
  },
};
</script>
